export default __webpack_public_path__ + "static/media/hippa-compliance-white.87eca163.webp";